import Reflux from 'reflux';

const RefreshActions = Reflux.createActions([
  'changeInterval',
  'disable',
  'enable',
]);

export default RefreshActions;



// WEBPACK FOOTER //
// ./src/actions/tools/RefreshActions.jsx